<template>
  <div class="about-container">
    <div class="content-wrapper">
      <h2 class="title">{{ title }}</h2>
      <div class="content-box">
        <p>{{ content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "About me",
    },
   content: {
      type: String,
      default: `I'm a forward-thinking professional who loves turning ideas into action. Technology fascinates me. Experimenting with the latest tools and gadgets is my way of staying ahead. I enjoy helping organizations leverage tech to streamline operations and boost efficiency.
Beyond my passion for tech, I’m all about teamwork: I thrive on collaboration and do my best to motivate those around me. Balancing a busy career with a young family means sleep can be scarce, so I practically run on coffee. When it’s time to recharge, I hit the trails for a run.It’s my go-to method for clearing my mind and staying energized.
`,
    }
  },
  computed: {
    pageTitle() {
      return this.title;
    },
    pageContent() {
      return this.content;
    }
  }
};
</script>

<style scoped>
.about-container {
  min-height: 100vh;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.content-wrapper {
  max-width: 65ch; /* Optimal line length for readability */
  width: 100%;
  padding: 4rem 2rem;
}

.title {
  font-family: 'Space Grotesk', sans-serif; /* Consider importing this font */
  font-size: 3.5rem;
  font-weight: 300;
  color: #1a1a1a;
  margin-bottom: 3rem;
  letter-spacing: -1.5px;
  line-height: 1.1;
}

.content-box {
  position: relative;
  padding-left: 2rem;
  border-left: 1px solid #ddd;
}

p {
  font-family: 'Inter', sans-serif; /* Consider importing this font */
  font-size: 1.125rem;
  line-height: 1.75;
  color: #404040;
  white-space: pre-wrap;
  margin: 0;
  font-weight: 300;
  letter-spacing: 0.01em;
}

/* Subtle animation on page load */
.content-wrapper {
  animation: fadeIn 0.8s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 2rem 1rem;
  }
  
  .title {
    font-size: 2.5rem;
  }
  
  .content-box {
    padding-left: 1rem;
  }
  
  p {
    font-size: 1rem;
  }
}
</style>
